(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {
const mobileQuery = window.matchMedia('(max-width: 989px)');
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const footerCleanups = new WeakMap();
const transitionTimers = new WeakMap();
const setInert = (element, inert) => {
if ('inert' in element) {
element.inert = inert;
}
element.setAttribute('aria-hidden', inert ? 'true' : 'false');
};
const clearPanelTimer = (panel) => {
const timer = transitionTimers.get(panel);
if (timer) window.clearTimeout(timer);
transitionTimers.delete(panel);
};
const setPanelState = (button, panel, expanded, options = {}) => {
const animate = options.animate !== false && !reducedMotionQuery.matches;
button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
clearPanelTimer(panel);
if (!animate) {
panel.hidden = !expanded;
panel.style.height = '';
panel.style.opacity = '';
setInert(panel, !expanded);
return;
}
if (expanded) {
panel.hidden = false;
setInert(panel, false);
panel.style.height = '0px';
panel.style.opacity = '0';
window.requestAnimationFrame(() => {
panel.style.height = `${panel.scrollHeight}px`;
panel.style.opacity = '1';
});
const timer = window.setTimeout(() => {
panel.style.height = 'auto';
transitionTimers.delete(panel);
}, 300);
transitionTimers.set(panel, timer);
return;
}
setInert(panel, true);
panel.hidden = false;
panel.style.height = `${panel.scrollHeight}px`;
panel.style.opacity = '1';
window.requestAnimationFrame(() => {
panel.style.height = '0px';
panel.style.opacity = '0';
});
const timer = window.setTimeout(() => {
panel.hidden = true;
panel.style.height = '';
panel.style.opacity = '';
transitionTimers.delete(panel);
}, 300);
transitionTimers.set(panel, timer);
};
const setupEntranceMotion = (footer, cleanupCallbacks) => {
footer.dataset.footerInView = 'true';
};
const initFooter = (root) => {
const footer = root.matches?.('.orlaven-footer') ? root : root.querySelector?.('.orlaven-footer');
if (!footer || footer.dataset.orlavenFooterInitialized === 'true') return;
footer.dataset.orlavenFooterInitialized = 'true';
const cleanupCallbacks = [];
setupEntranceMotion(footer, cleanupCallbacks);
footer.querySelectorAll('[data-footer-more-button]').forEach((button) => {
const panel = document.getElementById(button.getAttribute('aria-controls'));
if (!panel) return;
setPanelState(button, panel, false, { animate: false });
const onClick = () => {
setPanelState(button, panel, button.getAttribute('aria-expanded') !== 'true');
};
button.addEventListener('click', onClick);
cleanupCallbacks.push(() => button.removeEventListener('click', onClick));
});
const accordionButtons = Array.from(footer.querySelectorAll('[data-footer-accordion-button]'));
const syncAccordions = () => {
const nextMode = mobileQuery.matches ? 'mobile' : 'desktop';
const modeChanged = footer.dataset.orlavenFooterMode !== nextMode;
accordionButtons.forEach((button) => {
const panel = document.getElementById(button.getAttribute('aria-controls'));
if (!panel) return;
if (mobileQuery.matches) {
if (modeChanged) {
setPanelState(button, panel, false, { animate: false });
} else {
panel.hidden = button.getAttribute('aria-expanded') !== 'true';
setInert(panel, panel.hidden);
}
button.tabIndex = 0;
} else {
setPanelState(button, panel, true, { animate: false });
button.tabIndex = -1;
}
});
footer.dataset.orlavenFooterMode = nextMode;
};
accordionButtons.forEach((button) => {
const onClick = () => {
if (!mobileQuery.matches) return;
const panel = document.getElementById(button.getAttribute('aria-controls'));
if (!panel) return;
setPanelState(button, panel, button.getAttribute('aria-expanded') !== 'true');
};
button.addEventListener('click', onClick);
cleanupCallbacks.push(() => button.removeEventListener('click', onClick));
});
if (mobileQuery.addEventListener) {
mobileQuery.addEventListener('change', syncAccordions);
cleanupCallbacks.push(() => mobileQuery.removeEventListener('change', syncAccordions));
} else {
mobileQuery.addListener(syncAccordions);
cleanupCallbacks.push(() => mobileQuery.removeListener(syncAccordions));
}
syncAccordions();
footerCleanups.set(footer, cleanupCallbacks);
};
const initFooters = (root = document) => {
if (root.matches?.('.orlaven-footer')) {
initFooter(root);
}
root.querySelectorAll('.orlaven-footer').forEach(initFooter);
};
const destroyFooter = (root) => {
const footer = root.matches?.('.orlaven-footer') ? root : root.querySelector?.('.orlaven-footer');
if (!footer) return;
const cleanupCallbacks = footerCleanups.get(footer) || [];
cleanupCallbacks.forEach((cleanup) => cleanup());
footer.querySelectorAll('[data-footer-more-panel], [data-footer-accordion-panel]').forEach((panel) => {
clearPanelTimer(panel);
});
footerCleanups.delete(footer);
delete footer.dataset.orlavenFooterInitialized;
};
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initFooters());
} else {
initFooters();
}
document.addEventListener('shopify:section:load', (event) => initFooters(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyFooter(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orlaven-landing-sequence"] && !Shopify.designMode) return;
  try {
    
class OrjGenderEdit extends HTMLElement {
connectedCallback() {
if (this.dataset.orjReady === 'true') return;
this.dataset.orjReady = 'true';
this.tabs = Array.from(this.querySelectorAll('[data-orj-gender-tab]'));
this.panels = Array.from(this.querySelectorAll('[data-orj-gender-panel]'));
this.tabs.forEach((tab, index) => {
tab.addEventListener('click', () => this.selectTab(tab));
tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
});
}
handleKeydown(event, index) {
const lastIndex = this.tabs.length - 1;
let nextIndex = index;
if (event.key === 'ArrowRight') nextIndex = index === lastIndex ? 0 : index + 1;
if (event.key === 'ArrowLeft') nextIndex = index === 0 ? lastIndex : index - 1;
if (event.key === 'Home') nextIndex = 0;
if (event.key === 'End') nextIndex = lastIndex;
if (nextIndex === index) return;
event.preventDefault();
this.tabs[nextIndex].focus();
this.selectTab(this.tabs[nextIndex]);
}
selectTab(selectedTab) {
if (this.isSwitching || selectedTab.getAttribute('aria-selected') === 'true') return;
const selectedGender = selectedTab.dataset.orjGenderTab;
const currentPanel = this.panels.find((panel) => !panel.hidden);
const nextPanel = this.panels.find((panel) => panel.dataset.orjGenderPanel === selectedGender);
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const update = () => {
this.tabs.forEach((tab) => {
const isSelected = tab === selectedTab;
tab.classList.toggle('is-active', isSelected);
tab.setAttribute('aria-selected', String(isSelected));
tab.tabIndex = isSelected ? 0 : -1;
});
if (reduceMotion || !currentPanel || !nextPanel) {
this.panels.forEach((panel) => {
panel.hidden = panel.dataset.orjGenderPanel !== selectedGender;
});
return;
}
this.isSwitching = true;
nextPanel.hidden = false;
currentPanel.classList.add('is-transitioning-out');
nextPanel.classList.add('is-transitioning-in');
let isComplete = false;
const finishSwitch = () => {
if (isComplete) return;
isComplete = true;
nextPanel.removeEventListener('animationend', handleAnimationEnd);
window.clearTimeout(this.switchFallbackTimer);
currentPanel.hidden = true;
currentPanel.classList.remove('is-transitioning-out');
nextPanel.classList.remove('is-transitioning-in');
this.isSwitching = false;
};
const handleAnimationEnd = (event) => {
if (event.target === nextPanel && event.animationName === 'orj-gender-panel-in') {
finishSwitch();
}
};
nextPanel.addEventListener('animationend', handleAnimationEnd);
this.switchFallbackTimer = window.setTimeout(finishSwitch, 760);
};
update();
this.closest('.orj-home')?.dispatchEvent(new CustomEvent('orj:gender-change', {
detail: { gender: selectedGender }
}));
}
}
if (!customElements.get('orj-gender-edit')) {
customElements.define('orj-gender-edit', OrjGenderEdit);
}
class OrjEditorialHero extends HTMLElement {
connectedCallback() {
if (this.dataset.orjReady === 'true') return;
this.dataset.orjReady = 'true';
this.slides = Array.from(this.querySelectorAll('[data-orj-editorial-slide]'));
this.progressButtons = Array.from(this.querySelectorAll('[data-orj-editorial-go]'));
this.nextButton = this.querySelector('[data-orj-editorial-next]');
this.nextIcon = this.nextButton?.querySelector('span');
this.home = this.closest('.orj-home');
this.handleGenderChange = (event) => this.selectGender(event.detail.gender);
this.handleNext = () => {
const isWomen = this.dataset.orjActive === 'women';
this.selectGender(isWomen ? 'men' : 'women', true, isWomen ? 'next' : 'previous');
};
this.handleKeydown = (event) => {
if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
event.preventDefault();
this.selectGender(event.key === 'ArrowRight' ? 'men' : 'women', true, event.key === 'ArrowRight' ? 'next' : 'previous');
};
this.handlePointerDown = (event) => {
if (event.pointerType === 'mouse') return;
this.pointerStartX = event.clientX;
this.pointerStartY = event.clientY;
};
this.handlePointerUp = (event) => {
if (this.pointerStartX == null || this.pointerStartY == null) return;
const deltaX = event.clientX - this.pointerStartX;
const deltaY = event.clientY - this.pointerStartY;
this.pointerStartX = null;
this.pointerStartY = null;
if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
this.selectGender(deltaX < 0 ? 'men' : 'women', true, deltaX < 0 ? 'next' : 'previous');
};
this.handleVisibilityChange = () => {
if (document.hidden) {
this.clearAutoplay();
} else {
this.startAutoplay();
}
};
this.home?.addEventListener('orj:gender-change', this.handleGenderChange);
this.nextButton?.addEventListener('click', this.handleNext);
this.progressClickHandlers = new Map();
this.progressButtons.forEach((button) => {
const handleClick = () => {
const gender = button.dataset.orjEditorialGo;
this.selectGender(gender, true, gender === 'men' ? 'next' : 'previous');
};
this.progressClickHandlers.set(button, handleClick);
button.addEventListener('click', handleClick);
});
this.addEventListener('keydown', this.handleKeydown);
this.addEventListener('pointerdown', this.handlePointerDown, { passive: true });
this.addEventListener('pointerup', this.handlePointerUp, { passive: true });
document.addEventListener('visibilitychange', this.handleVisibilityChange);
const initialGender = this.querySelector('[data-orj-editorial-slide].is-active')?.dataset.orjEditorialSlide || 'women';
this.selectGender(initialGender, false);
if (!('IntersectionObserver' in window)) {
this.classList.add('is-visible');
this.inView = true;
this.startAutoplay();
return;
}
this.observer = new IntersectionObserver((entries) => {
this.inView = entries[0].isIntersecting;
if (this.inView) {
this.classList.add('is-visible');
this.startAutoplay();
} else {
this.clearAutoplay();
}
}, { rootMargin: '0px 0px -10% 0px', threshold: 0.18 });
this.observer.observe(this);
}
selectGender(gender, restartAutoplay = true, direction) {
const selectedSlide = this.slides.find((slide) => slide.dataset.orjEditorialSlide === gender);
if (!selectedSlide) return;
const previousGender = this.dataset.orjActive;
if (direction) this.dataset.orjDirection = direction;
else if (previousGender && previousGender !== gender) this.dataset.orjDirection = gender === 'men' ? 'next' : 'previous';
this.slides.forEach((slide) => {
const isSelected = slide === selectedSlide;
slide.classList.toggle('is-active', isSelected);
slide.setAttribute('aria-hidden', String(!isSelected));
slide.inert = !isSelected;
});
this.dataset.orjActive = gender;
this.progressButtons.forEach((button) => {
const isSelected = button.dataset.orjEditorialGo === gender;
button.classList.toggle('is-active', isSelected);
button.setAttribute('aria-current', String(isSelected));
});
const nextGender = gender === 'women' ? 'men' : 'women';
if (this.nextButton) this.nextButton.setAttribute('aria-label', `Show ${nextGender}'s editorial`);
if (this.nextIcon) this.nextIcon.textContent = gender === 'women' ? '→' : '←';
if (restartAutoplay) this.startAutoplay();
}
restartProgress() {
const activeButton = this.progressButtons.find((button) => button.classList.contains('is-active'));
if (!activeButton) return;
activeButton.classList.remove('is-active');
void activeButton.offsetWidth;
activeButton.classList.add('is-active');
}
startAutoplay() {
this.clearAutoplay();
if (!this.inView || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
this.restartProgress();
this.autoplayTimer = window.setTimeout(() => {
const nextGender = this.dataset.orjActive === 'women' ? 'men' : 'women';
this.selectGender(nextGender, true, nextGender === 'men' ? 'next' : 'previous');
}, 7000);
}
clearAutoplay() {
if (!this.autoplayTimer) return;
window.clearTimeout(this.autoplayTimer);
this.autoplayTimer = null;
}
disconnectedCallback() {
this.observer?.disconnect();
this.clearAutoplay();
this.home?.removeEventListener('orj:gender-change', this.handleGenderChange);
this.nextButton?.removeEventListener('click', this.handleNext);
this.progressClickHandlers?.forEach((handler, button) => button.removeEventListener('click', handler));
this.removeEventListener('keydown', this.handleKeydown);
this.removeEventListener('pointerdown', this.handlePointerDown);
this.removeEventListener('pointerup', this.handlePointerUp);
document.removeEventListener('visibilitychange', this.handleVisibilityChange);
}
}
if (!customElements.get('orj-editorial-hero')) {
customElements.define('orj-editorial-hero', OrjEditorialHero);
}
class OrjBagTabs extends HTMLElement {
connectedCallback() {
if (this.dataset.orjReady === 'true') return;
this.dataset.orjReady = 'true';
this.tabs = Array.from(this.querySelectorAll('[data-orj-bag-tab]'));
this.panels = Array.from(this.querySelectorAll('[data-orj-bag-panel]'));
this.tabs.forEach((tab, index) => {
tab.addEventListener('click', () => this.selectTab(tab));
tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
});
const section = this.closest('.orj-bags');
if (!section) return;
section.dataset.orjMotionReady = 'true';
if (
window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
!('IntersectionObserver' in window)
) {
section.classList.add('is-visible');
return;
}
this.observer = new IntersectionObserver((entries) => {
if (!entries[0].isIntersecting) return;
window.requestAnimationFrame(() => section.classList.add('is-visible'));
this.observer.disconnect();
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
this.observer.observe(section);
}
handleKeydown(event, index) {
if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
event.preventDefault();
let nextIndex = index;
if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
if (event.key === 'Home') nextIndex = 0;
if (event.key === 'End') nextIndex = this.tabs.length - 1;
this.tabs[nextIndex].focus();
this.selectTab(this.tabs[nextIndex]);
}
selectTab(selectedTab) {
if (selectedTab.getAttribute('aria-selected') === 'true') return;
const selectedGender = selectedTab.dataset.orjBagTab;
this.tabs.forEach((tab) => {
const isSelected = tab === selectedTab;
tab.classList.toggle('is-active', isSelected);
tab.setAttribute('aria-selected', String(isSelected));
tab.tabIndex = isSelected ? 0 : -1;
});
this.panels.forEach((panel) => {
const isSelected = panel.dataset.orjBagPanel === selectedGender;
panel.hidden = !isSelected;
panel.classList.remove('is-entering');
if (isSelected) {
void panel.offsetWidth;
panel.classList.add('is-entering');
}
});
}
disconnectedCallback() {
this.observer?.disconnect();
}
}
if (!customElements.get('orj-bag-tabs')) {
customElements.define('orj-bag-tabs', OrjBagTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orlaven-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const convert = (value, unit) => {
      if (unit === "cm") return value;
      return value.replace(/\d+(\.\d+)?/g, (number) => {
        const inches = Number(number) / 2.54;
        return Number.isInteger(inches) ? String(inches) : inches.toFixed(1);
      });
    };

    const init = (section) => {
      if (!section || section.dataset.ready === "true") return;
      section.dataset.ready = "true";
      const key = "orlaven-size-guide-unit";
      let unit = localStorage.getItem(key) || section.dataset.defaultUnit || "cm";
      const live = section.querySelector("[data-osg-live]");

      const render = () => {
        section.querySelectorAll("[data-cm]").forEach((cell) => {
          cell.textContent = convert(cell.dataset.cm, unit);
        });
        section.querySelectorAll("[data-osg-unit-label]").forEach((label) => {
          label.textContent = "(" + unit.toUpperCase() + ")";
        });
        section.querySelectorAll("[data-osg-unit]").forEach((button) => {
          button.setAttribute("aria-pressed", String(button.dataset.osgUnit === unit));
        });
        if (live) live.textContent = "Size guide unit changed to " + unit.toUpperCase() + ".";
      };

      section.querySelectorAll("[data-osg-unit]").forEach((button) => {
        button.addEventListener("click", () => {
          unit = button.dataset.osgUnit;
          localStorage.setItem(key, unit);
          render();
        });
      });

      render();
    };

    const initAll = (root = document) => root.querySelectorAll("[data-orlaven-size-guide]").forEach(init);
    document.addEventListener("DOMContentLoaded", () => initAll());
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
